<template>
  <div class="product-details">
    <banner :title="detail.Title || '产品详情'" subtitle="PRODUCT DETAILS" />
    <div class="detail-panel" v-loading="loading">
      <div class="detail-inner" v-if="detail.Id">
        <img v-if="detail.Img" class="cover" v-lazy="$img(detail.Img)" alt />
        <h1>{{ detail.Title }}</h1>
        <p class="summary" v-if="detail.Summary">{{ detail.Summary }}</p>
        <div class="rich-body" v-html="detail.Content"></div>
        <router-link class="back-link" to="/product">← 返回产品中心</router-link>
      </div>
      <div class="empty-tip" v-else-if="!loading">未找到该产品</div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";

export default {
  components: { Banner },
  data() {
    return {
      loading: true,
      detail: {}
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    "$route.params.id"() {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      const id = this.$route.params.id;
      this.loading = true;
      this.$http
        .get(`Product/${id}`)
        .then(response => {
          this.detail = response.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.detail = {};
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details {
  width: 100%;
  background: linear-gradient(180deg, #14679f 0%, #0f4f7d 100%);
  padding-bottom: 40px;
}

.detail-panel {
  width: 1240px;
  max-width: calc(100% - 32px);
  margin: -28px auto 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 -8px 30px rgba(8, 28, 46, 0.12);
  position: relative;
  z-index: 1;
}

.detail-inner {
  width: 860px;
  max-width: calc(100% - 48px);
  margin: 0 auto;
  padding: 40px 0 48px;

  .cover {
    width: 100%;
    max-height: 420px;
    object-fit: cover;
    border-radius: 12px;
    margin-bottom: 22px;
  }

  h1 {
    margin: 0;
    font-size: 28px;
    color: #17324a;
  }

  .summary {
    margin: 12px 0 0;
    color: #7a93a8;
    font-size: 14px;
    line-height: 1.7;
  }

  .rich-body {
    margin-top: 22px;
    color: #3d5568;
    font-size: 15px;
    line-height: 1.9;
  }

  .rich-body >>> h2 {
    margin: 24px 0 10px;
    color: #17324a;
    font-size: 22px;
  }

  .rich-body >>> h3 {
    margin: 18px 0 8px;
    color: #1f6fab;
    font-size: 18px;
  }

  .rich-body >>> img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 14px auto;
    border-radius: 10px;
  }

  .back-link {
    display: inline-block;
    margin-top: 28px;
    color: #1f6fab;
    text-decoration: none;
    font-size: 14px;
  }
}

.empty-tip {
  text-align: center;
  color: #7a93a8;
  padding: 80px 0;
}

@media (max-width: 720px) {
  .detail-inner {
    padding: 28px 0 36px;

    h1 {
      font-size: 22px;
    }

    .cover {
      max-height: 240px;
    }
  }
}
</style>
